
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"47","height":"53","viewBox":"0 0 47 53","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M41.778 5.222h-2.611V0h-5.223v5.222H13.056V0H7.833v5.222h-2.61C2.336 5.222.025 7.56.025 10.444L0 47a5.22 5.22 0 005.222 5.222h36.556A5.22 5.22 0 0047 47V10.444a5.22 5.22 0 00-5.222-5.222zm0 41.778H5.222V18.278h36.556V47z","fill":"#324997"}}),_c('path',{attrs:{"d":"M23.498 35.406l-6.37 6.371-2.769-2.767 6.371-6.372-6.37-6.37 2.767-2.768 6.371 6.37 6.371-6.37 2.768 2.767-6.371 6.371 6.371 6.372-2.768 2.767-6.37-6.37z","fill":"#324997"}})])
          )
        }
      }
    